import LoginForm from '../Components/LoginForm';
import { useSignOut } from 'react-auth-kit';
import { useEffect } from 'react';
import { performLogout } from '../Functions/session';

const Login = () => {
    const signOut = useSignOut()

    function LogOut() {
        performLogout(signOut)
    }

    useEffect(() => {
        LogOut()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div className='eb-login-page'>
            <LoginForm />
        </div>
    );
};

export default Login;
